import { activityCountsByIndependentWork } from '@web/lib/demo/procedures/activityCountsByIndependentWork';
import { activitySummaryHeatmap } from '@web/lib/demo/procedures/activitySummaryHeatmap';
import { alertsSummary } from '@web/lib/demo/procedures/alertsSummary';
import { allOrgUnits } from '@web/lib/demo/procedures/allOrgUnits';
import { allUsers } from '@web/lib/demo/procedures/allUsers';
import { breaksDuringWorkIndicator } from '@web/lib/demo/procedures/breaksDuringWorkIndicator';
import { chatActivity } from '@web/lib/demo/procedures/chatActivity';
import { chatActivityBreakdown } from '@web/lib/demo/procedures/chatActivityBreakdown';
import { chatAnalytic } from '@web/lib/demo/procedures/chatAnalytic';
import { chatMessageActivity } from '@web/lib/demo/procedures/chatMessageActivity';
import { chatResponseSpeedAndFrequency } from '@web/lib/demo/procedures/chatResponseSpeedAndFrequency';
import { chatRoomsByMessageVolume } from '@web/lib/demo/procedures/chatRoomsByMessageVolume';
import { chatSummary } from '@web/lib/demo/procedures/chatSummary';
import { communicationByChannel } from '@web/lib/demo/procedures/communicationByChannel';
import { communicationByCollaborativeTime } from '@web/lib/demo/procedures/communicationByCollaborativeTime';
import { communicationByLabel } from '@web/lib/demo/procedures/communicationByLabel';
import { communicationByPeerType } from '@web/lib/demo/procedures/communicationByPeerType';
import { communicationByWeekdays } from '@web/lib/demo/procedures/communicationByWeekdays';
import { communicationNetworkGraph } from '@web/lib/demo/procedures/communicationNetworkGraph';
import { communicationNetworkGraphInspector } from '@web/lib/demo/procedures/communicationNetworkGraphInspector';
import { communicationNetworkGraphLinkInspector } from '@web/lib/demo/procedures/communicationNetworkGraphLinkInspector';
import { communicationNetworkGraphSummaryCards } from '@web/lib/demo/procedures/communicationNetworkGraphSummaryCards';
import { consistencyOfAttendanceInMeets } from '@web/lib/demo/procedures/consistencyOfAttendanceInMeets';
import { createdAndOwnedFiles } from '@web/lib/demo/procedures/createdAndOwnedFiles';
import { createdItemsByType } from '@web/lib/demo/procedures/createdItemsByType';
import { createDocumentAlertConfig } from '@web/lib/demo/procedures/createDocumentAlertConfig';
import { createOrUpdateLabels } from '@web/lib/demo/procedures/createOrUpdateLabels';
import { currentUser } from '@web/lib/demo/procedures/currentUser';
import { daysWithExtendedWorkHours } from '@web/lib/demo/procedures/daysWithExtendedWorkHours';
import { deleteDocumentAlertConfig } from '@web/lib/demo/procedures/deleteDocumentAlertConfig';
import { deleteLabel } from '@web/lib/demo/procedures/deleteLabel';
import { deleteWorkspace } from '@web/lib/demo/procedures/deleteWorkspace';
import { docReviewCount } from '@web/lib/demo/procedures/docReviewCount';
import { docsSharedExternally } from '@web/lib/demo/procedures/docsSharedExternally';
import { docsSharedExternallyByLabel } from '@web/lib/demo/procedures/docsSharedExternallyByLabel';
import { documentActivity } from '@web/lib/demo/procedures/documentActivity';
import { documentActivityEventsAnalytic } from '@web/lib/demo/procedures/documentActivityEventsAnalytic';
import { documentAlertConfig } from '@web/lib/demo/procedures/documentAlertConfig';
import { documentAlertsList } from '@web/lib/demo/procedures/documentAlertsList';
import { documentEventsLog } from '@web/lib/demo/procedures/documentEventsLog';
import { documentFileSummary } from '@web/lib/demo/procedures/documentFileSummary';
import { documentInsights } from '@web/lib/demo/procedures/documentInsights';
import { documentItemHeader } from '@web/lib/demo/procedures/documentItemHeader';
import { documentsList } from '@web/lib/demo/procedures/documentList';
import { documents } from '@web/lib/demo/procedures/documents';
import { documentTimeline } from '@web/lib/demo/procedures/documentTimeline';
import { documentYearlyActivity } from '@web/lib/demo/procedures/documentYearlyActivity';
import { driveActionsOverTime } from '@web/lib/demo/procedures/driveActionsOverTime';
import { driveActivity } from '@web/lib/demo/procedures/driveActivity';
import { driveAnalytic } from '@web/lib/demo/procedures/driveAnalytic';
import { driveDocumentsActivity } from '@web/lib/demo/procedures/driveDocumentsActivity';
import { drivePeopleActivity } from '@web/lib/demo/procedures/drivePeopleActivity';
import { driveSummary } from '@web/lib/demo/procedures/driveSummary';
import { emailResponseSpeedAndFrequency } from '@web/lib/demo/procedures/emailResponseSpeedAndFrequency';
import { emailSummaryReplyRate } from '@web/lib/demo/procedures/emailSummaryReplyRate';
import { events } from '@web/lib/demo/procedures/events';
import { geminiActionBreakdown } from '@web/lib/demo/procedures/geminiActionBreakdown';
import { geminiAdoptionTrend } from '@web/lib/demo/procedures/geminiAdoptionTrend';
import { geminiSummary } from '@web/lib/demo/procedures/geminiSummary';
import { geminiUsageCategoryByApp } from '@web/lib/demo/procedures/geminiUsageCategoryByApp';
import { geminiUsageLevelDistribution } from '@web/lib/demo/procedures/geminiUsageLevelDistribution';
import { geminiUserSummary } from '@web/lib/demo/procedures/geminiUserSummary';
import { getAILabels } from '@web/lib/demo/procedures/getAILabels';
import { getAllLabels } from '@web/lib/demo/procedures/getAllLabels';
import { getDocumentUsers } from '@web/lib/demo/procedures/getDocumentUsers';
import { getInsight } from '@web/lib/demo/procedures/getInsight';
import { getMeetById } from '@web/lib/demo/procedures/getMeetById';
import { getOfficeIpSuggestions } from '@web/lib/demo/procedures/getOfficeIpSuggestions';
import { getRecurringMeetings } from '@web/lib/demo/procedures/getRecurringMeetings';
import { gmailActionsOverTime } from '@web/lib/demo/procedures/gmailActionsOverTime';
import { gmailAnalytic } from '@web/lib/demo/procedures/gmailAnalytic';
import { gmailSummary } from '@web/lib/demo/procedures/gmailSummary';
import { individualCommTime } from '@web/lib/demo/procedures/individualCommTime';
import { invocationsByApp } from '@web/lib/demo/procedures/invocationsByApp';
import { invocationsByUser } from '@web/lib/demo/procedures/invocationsByUser';
import { meetAdvancedSearch } from '@web/lib/demo/procedures/meetAdvancedSearch';
import { meetingAnalytic } from '@web/lib/demo/procedures/meetingAnalytic';
import { meetingDurationAnalytic } from '@web/lib/demo/procedures/meetingDurationAnalytic';
import { meetingLoadAnalytic } from '@web/lib/demo/procedures/meetingLoadAnalytic';
import { meetingsBackToBackAnalytic } from '@web/lib/demo/procedures/meetingsBackToBackAnalytic';
import { meetingsByLengthAnalytic } from '@web/lib/demo/procedures/meetingsByLengthAnalytic';
import { meetingsByScheduleAnalytic } from '@web/lib/demo/procedures/meetingsByScheduleAnalytic';
import { meetingsBySizeAnalytic } from '@web/lib/demo/procedures/meetingsBySizeAnalytic';
import { meetingsByTimePeriod } from '@web/lib/demo/procedures/meetingsByTimePeriod';
import { meetingsByWhenAnalytic } from '@web/lib/demo/procedures/meetingsByWhenAnalytic';
import { meetingsByWhoAttendedAnalytic } from '@web/lib/demo/procedures/meetingsByWhoAttendedAnalytic';
import { meetingsPlannedVsActualAnalytic } from '@web/lib/demo/procedures/meetingsPlannedVsActualAnalytic';
import { meetingsTypesAnalytic } from '@web/lib/demo/procedures/meetingsTypesAnalytic';
import { meetInsights } from '@web/lib/demo/procedures/meetInsights';
import { meetSummary } from '@web/lib/demo/procedures/meetSummary';
import { mostFrequentCommunicationPartners } from '@web/lib/demo/procedures/mostFrequentCommunicationPartners';
import { mostPopularDocuments } from '@web/lib/demo/procedures/mostPopularDocuments';
import { orgUnits } from '@web/lib/demo/procedures/orgUnits';
import { payproCheckout } from '@web/lib/demo/procedures/payproCheckout';
import { payproSuspendSubscription } from '@web/lib/demo/procedures/payproSuspendSubscription';
import { plannedVSAdHocMeetings } from '@web/lib/demo/procedures/plannedVSAdHocMeetings';
import { scheduledMeetAttendanceRate } from '@web/lib/demo/procedures/scheduledMeetAttendanceRate';
import { sharedFiles } from '@web/lib/demo/procedures/sharedFiles';
import { subscriptionData } from '@web/lib/demo/procedures/subscriptionData';
import { subscriptionPlans } from '@web/lib/demo/procedures/subscriptionPlans';
import { timeSpentOnActivities } from '@web/lib/demo/procedures/timeSpentOnActivities';
import { timeSpentOnWorkActivities } from '@web/lib/demo/procedures/timeSpentOnWorkActivities';
import { topChatters } from '@web/lib/demo/procedures/topChatters';
import { topRecurringEventsAndMeetings } from '@web/lib/demo/procedures/topRecurringEventsAndMeetings';
import { updateDocumentAlertConfig } from '@web/lib/demo/procedures/updateDocumentAlertConfig';
import { updateInsight } from '@web/lib/demo/procedures/updateInsight';
import { updateOrgUnitActive } from '@web/lib/demo/procedures/updateOrgUnitActive';
import { updateSubscription } from '@web/lib/demo/procedures/updateSubscription';
import { updateUser } from '@web/lib/demo/procedures/updateUser';
import { updateUserOrgUnit } from '@web/lib/demo/procedures/updateUserOrgUnit';
import { updateWorkspaceSettings } from '@web/lib/demo/procedures/updateWorkspaceSettings';
import { userActivityOnResolving } from '@web/lib/demo/procedures/userActivityOnResolving';
import { userLastActivity } from '@web/lib/demo/procedures/userLastActivity';
import { users } from '@web/lib/demo/procedures/users';
import { userTimeline } from '@web/lib/demo/procedures/userTimeline';
import { workdayAlignmentWithTeam } from '@web/lib/demo/procedures/workdayAlignmentWithTeam';
import { workingTimeAllocationByLabel } from '@web/lib/demo/procedures/workingTimeAllocationByLabel';
import { workLocationBreakdown } from '@web/lib/demo/procedures/workLocationBreakdown';
import { workspace } from '@web/lib/demo/procedures/workspace';
export var demoData = {
    workspace: workspace,
    currentUser: currentUser,
    updateUser: updateUser,
    updateWorkspaceSettings: updateWorkspaceSettings,
    gmailAnalytic: gmailAnalytic,
    gmailActionsOverTime: gmailActionsOverTime,
    gmailSummary: gmailSummary,
    driveSummary: driveSummary,
    driveActionsOverTime: driveActionsOverTime,
    driveDocumentsActivity: driveDocumentsActivity,
    documentActivity: documentActivity,
    driveAnalytic: driveAnalytic,
    documentInsights: documentInsights,
    users: users,
    orgUnits: orgUnits,
    allOrgUnits: allOrgUnits,
    allUsers: allUsers,
    events: events,
    documentActivityEventsAnalytic: documentActivityEventsAnalytic,
    timeSpentOnWorkActivities: timeSpentOnWorkActivities,
    meetingDurationAnalytic: meetingDurationAnalytic,
    meetingLoadAnalytic: meetingLoadAnalytic,
    meetingsBackToBackAnalytic: meetingsBackToBackAnalytic,
    meetingsByLengthAnalytic: meetingsByLengthAnalytic,
    meetingsByScheduleAnalytic: meetingsByScheduleAnalytic,
    meetingsBySizeAnalytic: meetingsBySizeAnalytic,
    meetingsByWhenAnalytic: meetingsByWhenAnalytic,
    meetingsByWhoAttendedAnalytic: meetingsByWhoAttendedAnalytic,
    meetingsPlannedVsActualAnalytic: meetingsPlannedVsActualAnalytic,
    userLastActivity: userLastActivity,
    activitySummaryHeatmap: activitySummaryHeatmap,
    meetingAnalytic: meetingAnalytic,
    meetingsTypesAnalytic: meetingsTypesAnalytic,
    meetInsights: meetInsights,
    meetSummary: meetSummary,
    userTimeline: userTimeline,
    driveActivity: driveActivity,
    alertsSummary: alertsSummary,
    documentAlertConfig: documentAlertConfig,
    updateDocumentAlertConfig: updateDocumentAlertConfig,
    documents: documents,
    deleteWorkspace: deleteWorkspace,
    createDocumentAlertConfig: createDocumentAlertConfig,
    documentAlertsList: documentAlertsList,
    deleteDocumentAlertConfig: deleteDocumentAlertConfig,
    getInsight: getInsight,
    chatActivity: chatActivity,
    chatActivityBreakdown: chatActivityBreakdown,
    chatMessageActivity: chatMessageActivity,
    chatSummary: chatSummary,
    chatAnalytic: chatAnalytic,
    chatResponseSpeedAndFrequency: chatResponseSpeedAndFrequency,
    emailResponseSpeedAndFrequency: emailResponseSpeedAndFrequency,
    updateInsight: updateInsight,
    subscriptionPlans: subscriptionPlans,
    documentsList: documentsList,
    documentItemHeader: documentItemHeader,
    drivePeopleActivity: drivePeopleActivity,
    getDocumentUsers: getDocumentUsers,
    documentYearlyActivity: documentYearlyActivity,
    documentEventsLog: documentEventsLog,
    documentFileSummary: documentFileSummary,
    documentTimeline: documentTimeline,
    meetAdvancedSearch: meetAdvancedSearch,
    getMeetById: getMeetById,
    getRecurringMeetings: getRecurringMeetings,
    updateOrgUnitActive: updateOrgUnitActive,
    updateUserOrgUnit: updateUserOrgUnit,
    payproCheckout: payproCheckout,
    getAllLabels: getAllLabels,
    createOrUpdateLabels: createOrUpdateLabels,
    deleteLabel: deleteLabel,
    subscriptionData: subscriptionData,
    payproSuspendSubscription: payproSuspendSubscription,
    updateSubscription: updateSubscription,
    getAILabels: getAILabels,
    getOfficeIpSuggestions: getOfficeIpSuggestions,
    communicationByChannel: communicationByChannel,
    emailSummaryReplyRate: emailSummaryReplyRate,
    communicationByCollaborativeTime: communicationByCollaborativeTime,
    geminiSummary: geminiSummary,
    geminiAdoptionTrend: geminiAdoptionTrend,
    geminiActionBreakdown: geminiActionBreakdown,
    geminiUsageCategoryByApp: geminiUsageCategoryByApp,
    geminiUsageLevelDistribution: geminiUsageLevelDistribution,
    geminiUserSummary: geminiUserSummary,
    invocationsByApp: invocationsByApp,
    invocationsByUser: invocationsByUser,
    communicationByLabel: communicationByLabel,
    communicationByPeerType: communicationByPeerType,
    mostFrequentCommunicationPartners: mostFrequentCommunicationPartners,
    chatRoomsByMessageVolume: chatRoomsByMessageVolume,
    topChatters: topChatters,
    communicationByWeekdays: communicationByWeekdays,
    meetingsByTimePeriod: meetingsByTimePeriod,
    createdItemsByType: createdItemsByType,
    mostPopularDocuments: mostPopularDocuments,
    topRecurringEventsAndMeetings: topRecurringEventsAndMeetings,
    docReviewCount: docReviewCount,
    userActivityOnResolving: userActivityOnResolving,
    consistencyOfAttendanceInMeets: consistencyOfAttendanceInMeets,
    workdayAlignmentWithTeam: workdayAlignmentWithTeam,
    workLocationBreakdown: workLocationBreakdown,
    plannedVSAdHocMeetings: plannedVSAdHocMeetings,
    activityCountsByIndependentWork: activityCountsByIndependentWork,
    createdAndOwnedFiles: createdAndOwnedFiles,
    sharedFiles: sharedFiles,
    timeSpentOnActivities: timeSpentOnActivities,
    docsSharedExternally: docsSharedExternally,
    docsSharedExternallyByLabel: docsSharedExternallyByLabel,
    scheduledMeetAttendanceRate: scheduledMeetAttendanceRate,
    daysWithExtendedWorkHours: daysWithExtendedWorkHours,
    breaksDuringWorkIndicator: breaksDuringWorkIndicator,
    individualCommTime: individualCommTime,
    workingTimeAllocationByLabel: workingTimeAllocationByLabel,
    communicationNetworkGraph: communicationNetworkGraph,
    communicationNetworkGraphInspector: communicationNetworkGraphInspector,
    communicationNetworkGraphLinkInspector: communicationNetworkGraphLinkInspector,
    communicationNetworkGraphSummaryCards: communicationNetworkGraphSummaryCards
};
